export default "__VITE_ASSET__4f7e3281__"